import axios from 'utils/axios';
import * as types from './ActionTypes';
import { API_URL } from 'configs';


import { showSuccessModal } from 'actions';

const loader = label => ({ type: types.SHOW_LOADER, common_loader_label: label });
const hideLoader = () => ({ type: types.HIDE_LOADER });

const snackbar = (msg, type = 'general_error') => ({
  type: types.SHOW_SNACKBAR,
  snackbar_notification: msg,
  snackbar_notification_type: type,
});

const handleError = (error, dispatch, validationType) => {
  const res = error?.response; 
  if (res?.status === 422){ 
    dispatch({ type: validationType, validation_error: res.data.errors });
  } 
  else dispatch(snackbar(res?.data?.error || `${res?.status} ${res?.statusText}`));
};

export const programRedirectToList = () => ({ type: types.PROGRAMS_REDIRECT });

const fetchSuccess = (type, listKey) => data => ({
  type,
  [listKey]: data
});

const getSuccess = (type) => (data, action) => ({
  type,
  record: data,
  actionType: action
});

export const hideProgramValidationError = (feild_key) => ({
  type: types.HIDE_PROGRAMS_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const fetchPrograms = (params = {}) => dispatch => {
  dispatch({ type: types.PROGRAMS_REQUEST });
  dispatch(loader());

  axios.post(`${API_URL}admin/programs/list`, params, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(fetchSuccess(types.PROGRAMS_SUCCESS, 'programsList')(res.data));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.PROGRAMS_VALIDATION_ERROR);
    });
};

export const getProgramById = (id, actionType, object_viewed_id) => dispatch => {
  dispatch({ type: types.PROGRAMS_REQUEST });
  dispatch(loader());

  axios.get(`${API_URL}admin/programs/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(res => {
      dispatch(hideLoader());
      dispatch(getSuccess(types.PROGRAMS_GET_SUCCESS)(res.data, actionType));
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.PROGRAMS_VALIDATION_ERROR);
    });
};

export const createOrUpdateProgram = (data, method = 'POST', object_viewed_id) => dispatch => {
  dispatch({ type: types.PROGRAMS_REQUEST });
  dispatch(loader());

  const url = method === 'POST'
    ? `${API_URL}admin/programs`
    : `${API_URL}admin/programs/${data.id}`;

  axios({
    url,
    method,
    data,
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(showSuccessModal(`Program ${method === 'POST' ? 'created' : 'updated'} successfully`));
      dispatch(programRedirectToList());
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.PROGRAMS_VALIDATION_ERROR);
    });
};

export const deleteProgram = (id, object_viewed_id) => dispatch => {
  dispatch({ type: types.PROGRAMS_REQUEST });
  dispatch(loader());

  axios.delete(`${API_URL}admin/programs/${id}`, {
    params: { object_viewed_id },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
    .then(() => {
      dispatch(hideLoader());
      dispatch(snackbar('Program deleted', 'success'));
      dispatch(fetchPrograms({ object_viewed_id })); // Refetch list after delete
    })
    .catch(err => {
      dispatch(hideLoader());
      handleError(err, dispatch, types.PROGRAMS_VALIDATION_ERROR);
    });
};

export const fetchProgramsDropdown = (params) => dispatch => {
  dispatch({ type: types.PROGRAMS_REQUEST });
  axios.get(`${API_URL}admin/programs/dropdown`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${localStorage.getItem("token")}`
    },
    params
  })
    .then(res => {
      dispatch(fetchSuccess(types.PROGRAMS_DROPDOWN_SUCCESS, 'programsDropdownList')(res.data));
    })
    .catch(err => {
      handleError(err, dispatch, types.PROGRAMS_VALIDATION_ERROR);
    });
};

export const exportPrograms = (extraFilters, object_viewed_id) => dispatch => {
  dispatch(loader('Exporting...'));
  const token = localStorage.getItem("token");
  const url = `${API_URL}admin/programs/export`;

  axios.post(url, {...extraFilters, object_viewed_id}, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  .then(response => {
    const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlBlob;
    const contentDisposition = response.headers['content-disposition'];
    let filename = 'programs.xlsx';
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch.length > 1)
            filename = filenameMatch[1];
    }
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(urlBlob);
    dispatch(hideLoader());
  }).catch(error => {
    dispatch(hideLoader());
    handleError(error, dispatch);
  });
};
